import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import Avatar from '~/components/shared/Avatar';
import { isExternalUser, isAdminOrStaff } from '~/helpers/userRoleHelper';

const NavBarSupportedContent = () => {
  const { abilities, helpers } = Rails;
  const { currentUser, teams } = helpers;

  if (!currentUser) {
    return (
      <ul className="navbar-nav ml-auto my-2 my-lg-0">
        <li className="nav-item">
          <Dropdown.Item href="/users/sign_in">
            Log In / Register
          </Dropdown.Item>
        </li>
      </ul>
    );
  }

  const accountItems = [
    <Dropdown.Item key="settings" href="/users/edit">User Settings</Dropdown.Item>,
  ];

  if (isAdminOrStaff()) {
    accountItems.push(
      <Dropdown.Item key="phone" href="/users/phone_number/edit">Phone Number</Dropdown.Item>,
    );
  }

  if (isExternalUser()) {
    accountItems.push(
      <Dropdown.Item key="landing" href="/team/landing_page/edit">Landing Page</Dropdown.Item>,
    );
  }

  const teamItems = [];
  if (abilities.manageCurrentTeam) {
    teamItems.push(
      <Dropdown.Item key="team-settings" href="/team/edit">Account Settings</Dropdown.Item>,
      <Dropdown.Item key="team-members" href="/team/members">Manage Team</Dropdown.Item>,
      <Dropdown.Item key="team-billing" href={`${Rails.baseUrl}billing`}>Billing</Dropdown.Item>,
    );
  }

  return (
    <div className="navbar-collapse text-center-sm-down" id="navbarSupportedContent">
      <Dropdown>
        <Dropdown.Toggle className="shadow-none text-nowrap d-flex align-items-center" variant="link" id="user-dropdown">
          <Avatar
            name={currentUser?.name}
            avatar={currentUser?.avatar_url}
            sizeType="tiny"
            showTooltip={false}
          />
          <span className="font-weight-bold ml5 text-grey3">
            {currentUser.name || currentUser.email}
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {currentUser.admin && (
            <>
              <Dropdown.Item href="/houston" className="text-danger font-weight-bold">
                Admin
              </Dropdown.Item>
              <Dropdown.Divider />
            </>
          )}

          {accountItems}
          {teamItems}

          {_lodash.size(teams) > 0 && (
            <>
              <Dropdown.Divider />
              <h6 className="navbar-text text-uppercase text-muted ml20" disabled>
                Change Team
              </h6>
              {teams.map((team) => (
                <Dropdown.Item
                  key={`change-team-${team.id}`}
                  href={`/teams/${team.id}/switch`}
                >
                  {team.name}
                </Dropdown.Item>
              ))}
            </>
          )}

          <Dropdown.Divider />
          <Dropdown.Item href="/users/sign_out" rel="nofollow" data-method="delete">
            Log Out
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

NavBarSupportedContent.propTypes = {};

export default NavBarSupportedContent;
